import { CaseReducer, createReducer } from '@reduxjs/toolkit';

import {
  CLOSE_FILEPICKER,
  OPEN_FILEPICKER,
  OPEN_FILEPICKER_URL,
  CLOSE_FILEPICKER_URL,
} from '../actions';
import { MainPageStore } from '../models';
import { defaultState } from '../store';

type Re<P = unknown> = CaseReducer<MainPageStore, { payload: P; type: string }>;

const onOpenFilePicker: Re = (state) => ({
  ...state,
  isFilePickerOpen: true,
});

const onCloseFilePicker: Re = (state) => ({
  ...state,
  isFilePickerOpen: false,
});

const onOpenFilePickerUrl: Re = (state) => ({
  ...state,
  isFilePickerUrlOpen: true,
});

const onCloseFilePickerUrl: Re = (state) => ({
  ...state,
  isFilePickerUrlOpen: false,
});

/**
 * MainPage composed reducers
 */
const filePickerReducer = createReducer(defaultState, (builder) => {
  builder
    .addCase(OPEN_FILEPICKER, onOpenFilePicker)
    .addCase(CLOSE_FILEPICKER, onCloseFilePicker)
    .addCase(OPEN_FILEPICKER_URL, onOpenFilePickerUrl)
    .addCase(CLOSE_FILEPICKER_URL, onCloseFilePickerUrl);
});

export default filePickerReducer;
